export default "__VITE_ASSET__yhbavrtZ__"